// Shared Toggle-Logik für den "öffentlicher Auftraggeber"-Leitweg-ID-Block (ECOM-3665).
// Bewusst plain DOM (kein jQuery) — neue Dateien dürfen kein jQuery einführen.
// Die aufrufenden (jQuery-basierten) Dateien reichen ein HTMLElement (Form/Container) herein.

/**
 * Blendet den Leitweg-ID-Block ein/aus, setzt die Pflichtfeld-Markierung (Stern + `required`)
 * und schreibt das `IsPublicAuthority`-Hidden-Field abhängig vom übergebenen Zustand.
 *
 * @param formEl Das umschließende Form-/Container-Element, in dem die Felder gesucht werden.
 * @param isPublicAuthority `true` = öffentlicher Auftraggeber (Leitweg-ID Pflicht), `false` = geschäftlich.
 */
export function applyLeitwegIdState(formEl: HTMLElement | null | undefined, isPublicAuthority: boolean): void {
    if (!formEl) {
        return;
    }

    const row = formEl.querySelector<HTMLElement>('.js-leitwegid-row');
    const isPublicAuthorityField = formEl.querySelector<HTMLInputElement>('.input_IsPublicAuthority');

    if (isPublicAuthorityField) {
        isPublicAuthorityField.value = isPublicAuthority ? 'true' : 'false';
    }

    if (!row) {
        return;
    }

    const input = row.querySelector<HTMLInputElement>('.input_LeitwegId');
    const label = row.querySelector<HTMLElement>('label, .entry-label');

    if (isPublicAuthority) {
        row.classList.remove('hide');

        if (label) {
            label.classList.add('mandatory');
            if (!label.querySelector('sup')) {
                const sup = document.createElement('sup');
                sup.textContent = '*';
                label.append(' ', sup);
            }
        }

        // KuP-Adressen werden read-only (ohne .input_LeitwegId) gerendert — dann gibt es kein Input.
        if (input) {
            input.setAttribute('required', 'required');
        }
    } else {
        row.classList.add('hide');

        if (label) {
            label.classList.remove('mandatory');
            const sup = label.querySelector('sup');
            if (sup) {
                sup.remove();
            }
        }

        if (input) {
            input.removeAttribute('required');
            input.value = '';
        }
    }
}
